import { getPortalSdk } from 'portal-sdk';
import Stardog, { Connection as StardogConnection } from 'stardog';

import { isPortal } from 'bones/utils/portal/environment';

export const refetchConnectionToken = async (
  connectionIdx: number
): Promise<string | null> => {
  if (!isPortal()) {
    return null;
  }
  const sdk = getPortalSdk();
  if (!sdk) {
    return null;
  }

  const updatedConnection = await sdk.getConnectionByIndex(connectionIdx);
  return updatedConnection?.token || null;
};

export const runWithRefetchConnectionToken = async (
  stardogConnection: StardogConnection,
  connectionIdx: number,
  wrappedRequest: (stardogConn: StardogConnection) => Promise<Stardog.HTTP.Body>
) => {
  let response = await wrappedRequest(stardogConnection);
  if (response && response.status === 401) {
    const updatedToken = await refetchConnectionToken(connectionIdx);
    if (updatedToken) {
      // @ts-ignore
      // eslint-disable-next-line no-param-reassign
      stardogConnection.token = updatedToken;
      response = await wrappedRequest(stardogConnection);
    }
  }

  return response;
};
